export default "__VITE_PUBLIC_ASSET__f16528d6__"